import depart from '@/components/department/list'
let routes = [
  {
    path: '/depart',
    name: 'depart',
    component: depart,
    meta: {
      requiresAuth: true
    }
  }
]
export default { routes }


// WEBPACK FOOTER //
// ./src/router/dept.js